/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// tslint:disable
import { isError, RequestError } from './errors';
/**
 * Delay action for some time
 * @param delayInMs
 */
export async function delay(delayInMs) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, delayInMs);
    });
}
const defaultRetryStrategy = async (rCount, err) => {
    if (err instanceof RequestError && err.status < 500) {
        return false;
    }
    if (err instanceof TypeError || err instanceof RangeError || err instanceof ReferenceError) {
        return false;
    }
    if (rCount > 5) {
        return false;
    }
    await delay(1000 * rCount);
    return true;
};
/**
 * Retries failed promise
 */
export async function retry(fn, retryStrategy = defaultRetryStrategy) {
    let retryCount = 1;
    const request = async () => {
        try {
            const response = await fn();
            if (isError(response)) {
                throw response;
            }
            return response;
        }
        catch (err) {
            const shouldRetry = await retryStrategy(retryCount, err);
            if (shouldRetry) {
                retryCount += 1;
                return request();
            }
            return err;
        }
    };
    return request();
}
export function debounceTime(func, timeMs) {
    // tslint:disable-next-line: no-let
    let timeOut;
    return async (...args) => {
        return new Promise((resolve) => {
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                func(...args).then(() => resolve());
            }, timeMs);
        });
    };
}
export function throttleTime(fn, delayInMiliSeconds) {
    // tslint:disable
    let cache = undefined;
    return (...args) => {
        const getInit = () => {
            const result = fn(...args);
            if (result instanceof Promise) {
                return result.then((q) => {
                    cache = {
                        cache: q,
                        time: Date.now(),
                    };
                    return q;
                });
            }
            cache = {
                cache: result,
                time: Date.now(),
            };
            return result;
        };
        if (!cache) {
            return getInit();
        }
        const cacheDiff = Date.now() - cache.time;
        if (cacheDiff >= delayInMiliSeconds) {
            return getInit();
        }
        return cache.cache;
    };
}
